const supabase_url = "https://dgvviobuovhqcbmceotw.supabase.co";
const supabase_anon_key = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRndnZpb2J1b3ZocWNibWNlb3R3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjIwNTI4OTksImV4cCI6MTk3NzYyODg5OX0.VcEQmBUIEkwH7UC7Rnrl0cciPz2727T8z0-m-be-WTI";

const productImagesURL = "https://dgvviobuovhqcbmceotw.supabase.co/storage/v1/object/public/products/product";

export { supabase_url, supabase_anon_key, productImagesURL };
